import React, { useState } from "react";
import { QueryClient, QueryClientProvider } from "./react-query";
import { DateProvider } from "./context/DateContext";
import FirmwideSummaryPage from "./pages/firmwide-summary/FirmwideSummaryPage";

/**
 * G-Risk "Risk Framework" tab: a read-only copy of the Data360 app's Risk
 * Framework page (/firmwide-summary). It reads from the Data360 backend, so
 * thresholds come from the same database tables as the Data360 app.
 * Threshold editing stays in the Data360 app (single writer).
 */
export default function RiskFrameworkTab() {
  const [queryClient] = useState(() => new QueryClient());
  return (
    <QueryClientProvider client={queryClient}>
      <DateProvider>
        <FirmwideSummaryPage />
      </DateProvider>
    </QueryClientProvider>
  );
}
